import { formatCurrency } from '@/pages/admin/core/reports/config/report-configs'
import { MdAccountBalanceWallet } from 'react-icons/md'

interface PaymentRemainingProps {
    remainingToComplete: number | null | undefined
}

export default function PaymentRemaining({
    remainingToComplete,
}: PaymentRemainingProps) {
    if (!remainingToComplete || remainingToComplete <= 0) return null

    return (
        <div className="flex items-start gap-3 p-4 mb-3 bg-warning/10 border border-warning/30 rounded-xl">
            <MdAccountBalanceWallet className="text-2xl text-warning shrink-0 mt-0.5" />
            <div>
                <p className="font-semibold text-base-content">
                    Falta{remainingToComplete > 100 ? 'm' : ''}{' '}
                    {formatCurrency(remainingToComplete)} para completar o
                    pagamento
                </p>
                <p className="text-sm text-base-content/70 mt-1">
                    O valor total deste agendamento ainda não foi quitado.
                </p>
            </div>
        </div>
    )
}
